const BASE_URL_API = process.env.REACT_APP_BASE_API || "http://localhost:80";
// const BASE_URL_API = "http://localhost:80";

export { BASE_URL_API };
